"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var _kernel_store_types_1 = require("../../types");
var _kernel_container_1 = __importDefault(require("../../../container"));
function deserializeMediafile(mediafile) {
    return {
        aggregateValues: mediafile.aggregate_values,
        performerTitle: mediafile.performer_title,
        crossfadeDuration: mediafile.crossfade_duration,
        marksJson: mediafile.marks_json,
        id: mediafile.id,
        type: mediafile.type,
        bpm: mediafile.bpm,
        rms: mediafile.rms,
        duration: mediafile.duration,
    };
}
function deserializeStream(stream) {
    return __assign(__assign({}, stream), { blockPattern: stream.block_pattern });
}
function deserializeTimeString(time) {
    var _a = __read(time.split(":").map(function (num) { return Number(num); }), 3), h = _a[0], m = _a[1], _ = _a[2];
    return { h: h, m: m };
}
function deserializeBlock(block) {
    return {
        endDate: block.end_date ? (0, moment_timezone_1.default)(block.end_date) : undefined,
        startDate: block.start_date ? (0, moment_timezone_1.default)(block.start_date) : undefined,
        endDayTime: block.end_day_time ? deserializeTimeString(block.end_day_time) : undefined,
        startDayTime: block.start_day_time ? deserializeTimeString(block.start_day_time) : undefined,
        isSpecial: block.is_special,
        id: block.id,
        days: block.days,
        rules: block.rules,
        pattern: block.pattern,
    };
}
function deserializeGenerationSettings(settings) {
    var mediafiles = settings.mediafiles.map(function (mf) { return deserializeMediafile(mf); });
    return {
        numberMediafiles: settings.number_mediafiles,
        mediafiles: mediafiles,
        stream: deserializeStream(settings.stream),
        rotatedMediafiles: settings.rotated_mediafiles,
        onetooneSeparate: settings.one_to_one_separate,
        dislikedMediafiles: settings.disliked_mediafiles,
        silentMediafile: deserializeMediafile(settings.silent_mediafile),
        mediafileBlocks: settings.mediafile_blocks,
        allBlocks: settings.all_blocks.map(function (bl) { return deserializeBlock(bl); }),
        jingleGroups: [],
        timezone: settings.timezone,
        crossfade: settings.crossfade,
        lastRotations: [],
        startTime: (0, moment_timezone_1.default)(settings.start_time),
        adcampaigns: settings.adcampaigns.map(deserializeAdCampaign),
        availableMediafileIds: [],
        generationType: "correction",
        pattern: settings.with_music_cut ? "with_music_cut" : "without_music_cut",
        cutDuration: settings.cut_duration || 0,
    };
}
function deserializeAdCampaign(ad) {
    var _a;
    var promos = ad.promos.map(deserializeMediafile);
    var promoads = ad.promoad.map(deserializePromoAd);
    return {
        prevMediafileRequired: ad.prev_mediafile_required,
        oneDay: ad.one_day,
        sortedValueIds: ad.sorted_value_ids,
        endDayTime: ad.end_day_time ? deserializeTimeString(ad.end_day_time) : undefined,
        startDayTime: ad.start_day_time ? deserializeTimeString(ad.start_day_time) : undefined,
        endCompany: ad.end_company ? (0, moment_timezone_1.default)(ad.end_company) : undefined,
        startCompany: ad.start_company ? (0, moment_timezone_1.default)(ad.start_company) : undefined,
        sortedValueMediafiles: (_a = ad.sorted_value_mediafiles) !== null && _a !== void 0 ? _a : undefined,
        id: ad.id,
        days: ad.days,
        type: ad.type,
        infinitely: ad.infinitely,
        interval: ad.interval,
        period: ad.period,
        promos: __spreadArray([], __read(promos), false),
        promoad: __spreadArray([], __read(promoads), false),
    };
}
function deserializePromoAd(promo) {
    return {
        promoId: promo.promo_id,
        id: promo.id,
        time: deserializeTimeString(promo.time),
        order: promo.order,
    };
}
function deserializeGenerationMediafile(mediafile) {
    return __awaiter(this, void 0, void 0, function () {
        var fs, cacheState, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    fs = _kernel_container_1.default.get("FILESYSTEM");
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, fs.getFileCacheSize(fs.getFileLocalFilepath(mediafile.filename))];
                case 2:
                    _b.sent();
                    cacheState = true;
                    return [3, 4];
                case 3:
                    _a = _b.sent();
                    cacheState = false;
                    return [3, 4];
                case 4: return [2, __assign(__assign({}, mediafile), { files: [
                            {
                                filename: mediafile.filename,
                                cacheState: cacheState ? _kernel_store_types_1.EMediafileCacheState.CACHE : _kernel_store_types_1.EMediafileCacheState.NO_CACHE,
                                size: mediafile.size,
                                duration: mediafile.duration,
                                crcHash: mediafile.crcHash,
                            },
                        ], duration: mediafile.duration / 1000, cacheState: _kernel_store_types_1.EMediafileCacheState.NO_CACHE, lastPlaytime: Date.now(), meta: {
                            type: mediafile.type,
                            cueIn: mediafile.cueIn,
                            cueOut: mediafile.cueOut,
                            fadeIn: mediafile.fadeIn,
                            fadeOut: mediafile.fadeOut,
                            startNext: mediafile.startNext,
                            size: mediafile.size,
                            duration: mediafile.duration,
                        } })];
            }
        });
    });
}
exports.default = {
    deserializeGenerationSettings: deserializeGenerationSettings,
    deserializeGenerationMediafile: deserializeGenerationMediafile,
};
//# sourceMappingURL=index.js.map